module.exports = "#version 300 es\nprecision highp float;\n\nin vec2 fs_UV;\nout vec4 out_Col;\n\nuniform sampler2D u_frame0;\n\n\nvoid main()\n{\t\n\t\n\tvec4 sceneColor = texture(u_frame0, fs_UV);\n\n\tout_Col = max(vec4(0.0), pow( smoothstep(vec4(0.0), vec4(4.0), sceneColor), vec4(4.0)));\n\t\n\tout_Col.w = 1.0;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/highLight-frag.glsl
// module id = 35
// module chunks = 0